import { Component, Input, forwardRef } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FcinputComponent } from '../fcinput';
/**
 * fc-checkå¤éæ¡
 * 
 * å¤éæ¡
 * 
 * ä¸ç»å¯éé¡¹ä¸­æå¤é¡¹éæ©ã
 * 
 * ä¸ç»å¯éé¡¹ä¸­éè¦è¿è¡å¤é¡¹éæ©ï¼åç¬ä½¿ç¨å¯ä»¥è¡¨ç¤ºä¸¤ç§ç¶æä¹é´çåæ¢ï¼åswitchç±»ä¼¼ãåºå«å¨äºåæ¢switchä¼ç´æ¥è§¦åç¶ææ¹åï¼èfccheckä¸è¬ç¨äºç¶ææ è®°ï¼éè¦åæäº¤æä½éåã
 * 
 */
@Component({
    selector: 'fc-check',
    template: `
    <label [ngClass]="{'fc-readonly':_readonly ===true,'fc-check-small':fcSize === 'small','fc-check-default':fcSize === 'default','fc-check-large':fcSize === 'large'}" 
        nz-checkbox
        *ngIf="_options!==undefined&&_options.length===1&&fcShowLabel==='N'"
        nzDisabled="_disabled" [(ngModel)]="simpleOption"
        (ngModelChange)="valueOnChange($event)">
        {{ _options[0].label }}
    </label>
    <nz-checkbox-group [ngClass]="{'fc-readonly':_readonly ===true,'fc-vertical':_mode===true,'fc-check-small':fcSize === 'small','fc-check-default':fcSize === 'default','fc-check-large':fcSize === 'large'}"
    [ngModel]="_options" 
    (ngModelChange)="valueOnChange($event)" 
    *ngIf="_options!==undefined&&_options.length>1&&fcShowLabel==='N'"></nz-checkbox-group>
    <div nz-row  nzType="flex" class="rowspans"  *ngIf="fcShowLabel===undefined||fcShowLabel==='Y'">
        <div nz-col [nzSpan]="labelSpan" class="labelspans"><span *ngIf="fcRequired==='Y'" style="color:red">*</span>{{fcLabel}}</div>
        <div nz-col [nzSpan]="valueSpan">
            <label [ngClass]="{'fc-check-small':fcSize === 'small','fc-check-default':fcSize === 'default','fc-check-large':fcSize === 'large'}" nz-checkbox *ngIf="_options!==undefined&&_options.length===1" 
                nzDisabled="_disabled" [(ngModel)]="simpleOption" (ngModelChange)="valueOnChange($event)">
                {{ _options[0].label }}
            </label>
            <nz-checkbox-group 
            [ngClass]="{'fc-readonly':_readonly ===true,'fc-vertical':_mode===true,'fc-check-small':fcSize === 'small','fc-check-default':fcSize === 'default','fc-check-large':fcSize === 'large'}" 
            [ngModel]="_options" (ngModelChange)="valueOnChange($event)" *ngIf="_options!==undefined&&_options.length>1"
            disable></nz-checkbox-group>
            <div class="fc-help-text" *ngIf="'Y'===fcShowHelp">
                {{fcHelp}}
            </div>
            <div class="explain" *ngIf="_validator!==undefined&&_validator.show==='Y'">
                <div [hidden]="_validator.showValidator!=='required'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.required}}</div>
                </div>
                <div [hidden]="_validator.showValidator!=='maxLength'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.maxLength}}</div>
                </div>
                <div [hidden]="_validator.showValidator!=='customVal'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.customVal}}</div>
                </div>
            </div>
        </div> 
    </div>
    `,
    styles: [`
    .fc-readonly {
        pointer-events: none;
        color: #ccc;
    }
    :host ::ng-deep  .fc-readonly .ant-checkbox-checked .ant-checkbox-inner, .ant-checkbox-indeterminate .ant-checkbox-inner{
        background:#f5f5f5;
        border-color:#ccc;
    }
    .form-explain {
        position:relative;
    }
    .explain{
        white-space: nowrap;
        position:absolute;
        right: -1px;
        bottom: 24px;
        z-index:10;
    }
    .explain-inner {
        position:relative;
        color:red;
    }
    .explain-inner:after{
        content: '';
        width: 10px;
        height: 12px;
        display: block;
        background-color: #ffffff;
        border-right: 1px solid #e9e9e9;
        border-bottom: 1px solid #e9e9e9;
        position: absolute;
        bottom: -6px;
        right: 12px;
        transform: rotate(45deg);
        z-index: 0;
    }
    .explain-tips{
        padding: 0px 10px;
        background-color: #ffffff;
        border: 1px solid #e9e9e9;
        border-radius: 4px;
        font-size: 12px;
        height: 30px;
        line-height: 28px;
    }
    :host ::ng-deep .fc-vertical .ant-checkbox-wrapper {
        display: block;
    }
    `],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FccheckComponent),
        multi: true
    }]
})
export class FccheckComponent extends FcinputComponent {
    _a: boolean;
    /**æ¨¡å¼*/
    @Input()
    fcMode: string;
    _mode: boolean;
    /**labelå­æ®µåç§°*/
    @Input()
    fcLabelCode: string;
    /**valueå­æ®µåç§°*/
    @Input()
    fcValueCode: string;
    /**disabledå­æ®µåç§°*/
    @Input()
    fcDisabledCode: string;
    simpleOption: any
    /** åéå¼*/
    @Input()
    fcOption: any[] = [];
    _options: any[] = [];
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-check');
        if (this.fcLabelCode === undefined) {
            this.fcLabelCode = 'label';
        }
        if (this.fcValueCode === undefined) {
            this.fcValueCode = 'value';
        }
        if (this.fcDisabledCode === undefined) {
            this.fcDisabledCode = 'disabled';
        }
        if (this.fcShowLabel === undefined) {
            this.fcShowLabel = "Y";
        }
        /** this._a = this.fcDisabled;*/
    }
    _afterParentInit() {
        if (this.fcMode === "Y") {
            this._mode = true;
        } else {
            this._mode = false;
        }
        this._options = [];
        this.fcOption.forEach(element => {
            const el = { label: element[this.fcLabelCode], value: element[this.fcValueCode], disabled: false, checked: element.checked ? element.checked : false };
            if (this._innerValue !== null && this._innerValue !== undefined) {
                if (typeof this._innerValue === 'string' && this._innerValue.indexOf(element[this.fcValueCode]) !== -1) {
                    el.checked = true;
                } else if (this._innerValue instanceof Array && this._innerValue.filter(v => v.value === element[this.fcValueCode]).length !== 0) {
                    el.checked = true;
                }
            } else if(element.checked === undefined) {
                el.checked = false;
            }
            if (element.hasOwnProperty(this.fcDisabledCode)) {
                el.disabled = element[this.fcDisabledCode];
            }
            this._options.push(el);
        })
        /**æ¯å¦ç¦ç¨*/
        if (this.fcDisabled === 'Y') {
            this._disabled = true;
        } else {
            this._disabled = false;
        }
        /**æ¯å¦åªè®*/
        if (this.fcReadonly === 'Y') {
            this._readonly = true;
        } else {
            this._readonly = false;
        }
    }
    public valueOnChange(allOptions: any[]): void {
        if (this._options instanceof Array && this._options.length > 1) {
            this._innerValue = '';
            this._options.forEach(element => {
                if (element.checked) {
                    this._innerValue += element.value + ',';
                }
            });
            if (this._innerValue.length !== 0) {
                this._innerValue = this._innerValue.substr(0, this._innerValue.length - 1);
            }
        } else if (this.simpleOption) {
            this._innerValue = this.fcOption[0][this.fcValueCode];
        }
        this.checkValidator(this._innerValue);
        this.onChangeCallback(this._innerValue);
    }
}
